import { FormattedMessage } from "react-intl";

import { TruncatedText } from "@citrine/atoms/truncated-text";
import type { TranslationID } from "@citrine/lang/utils";
import type { DataFullstoryId } from "@citrine/types/full-story";
import { formatDatetime } from "@citrine/utils/datetime";

import * as sx from "./dataset-activity-link.sx";

export function DatasetActivityLink({
  datasetName,
  datasetId,
  teamId,
  updateDate,
  updateDateTranslationId,
  "data-testid": testId,
  "data-fullstoryid": fullstoryId,
  borderColor,
  className,
}: {
  "data-testid"?: string;
  "data-fullstoryid"?: DataFullstoryId;
  datasetName?: string;
  datasetId: string;
  teamId: string;
  updateDate: number;
  updateDateTranslationId: TranslationID;
  borderColor?: string;
  className?: string;
}) {
  const formattedDate = updateDate
    ? formatDatetime(updateDate, "DD MMMM YYYY")
    : undefined;

  return (
    <sx.ActivityLink
      data-testid={testId}
      data-fullstoryid={fullstoryId}
      className={className}
      sx={
        borderColor
          ? {
              borderColor,
            }
          : undefined
      }
      to={`/data-manager/teams/${teamId}/materials?dataset=${datasetId}`}
    >
      <sx.Title variant="body1">
        <TruncatedText title={datasetName}>{datasetName || ""}</TruncatedText>
        <sx.Icon fontSize="small" />
      </sx.Title>

      <sx.Subtitle variant="caption">
        <TruncatedText title={formattedDate} tooltip={Boolean(formattedDate)}>
          <FormattedMessage id={updateDateTranslationId} />
          {": "}
          {formattedDate ?? "—"}
        </TruncatedText>
      </sx.Subtitle>
    </sx.ActivityLink>
  );
}
